<template>
  <v-row>
    <v-col>
      <v-sheet
        outlined>
        <!-- Lateral con la lista de contactos -->
        <v-row>
          <!-- Área principal con los mensajes del contacto seleccionado -->
          <v-col cols="12">

            <v-sheet height="80vh">
              <section class="section-chat pa-4">
                <div
                  v-for="chat in messages"
                  :key="chat.id"
                  class="text-left pt-1"
                  :class="{ 'text-right': chat.sender_id==user.user_id }">

                    <v-chip
                      medium
                      :color="(chat.sender_id==user.user_id)?'primary':'error'"
                      >
                      {{ chat.message }}
                    </v-chip>

                </div>
                <v-divider class="mt-2" id="divider"></v-divider>
              </section>
              
              <section class="section-message">
                <v-col cols="12">
                  <v-text-field
                    :disabled="sending"
                    outlined
                    v-model="message"
                    @keyup.enter="sendMessage"
                    label="Escribe un mensaje"
                    placeholder="Enter para enviar">
                  </v-text-field>
                </v-col>  
              </section>
            </v-sheet>

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Chat',
  data() {
    return {
      loading:true,
      sending:false,
      show_messages:false,
      selectedContact:null,
      chat_id:null,
      message:null,
      receiver_id:null,
      messages: [],
      contact: [],
    };
  },
  computed: {
    ...mapGetters([ 
        'user', 'edition'
    ])
  },
  mounted() {
    this.show_messages = true; // Muestra el v-sheet después de montar el componente
  },
  methods: {
    scrollToItem() {
      setTimeout(() => {
        let element = document.getElementById('divider');
        console.log(element)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          // element.scrollIntoView({ behavior: 'smooth', top: element.offsetTop, })
        }
      }, 100);
    },

    scrollToElement() {
      setTimeout(() => {
        const element = document.getElementById('divider');
        this.$el.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        });
      }, 100);
    },

    isStartDateValid() {
      const startDate = this.edition.edition.start_date_public_access;
      const currentDate = new Date();
            
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Agrega un 0 al mes si es necesario
      const day = String(currentDate.getDate()).padStart(2, '0'); // Agrega un 0 al día si es necesario

      const formattedDate = `${year}-${month}-${day}`;
      this.show_chat = startDate <= formattedDate;
    },

    selectContact(contact) {
      this.show_messages = false
      this.selectedContact = contact.id;
      this.show_messages = true
    },

    getInfoContact(){
      alert('nada')
    },

    async getChat(){
      this.loading = true
      this.receiver_id = this.chat_id
      this.message = null

      await axios.get('messages/'+this.chat_id).then(response =>{
          this.messages = response.data.data.messages
          this.scrollToItem()
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
    },

    async sendMessage(){
      this.sending = true
      try {
        await axios.post('messages',{
          message: this.message, 
          receiver_id: this.receiver_id, 
          }).then(response =>{
            this.sending = false
            this.message = ''
            this.updateChat(this.receiver_id)
            console.log(response)
          })
        } catch (error) {
            this.sending = false
            this.message = ''
            this.dialog_message = false
            console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
    },

    async updateChat(id){
      await axios.get('messages/'+id).then(response =>{
          this.messages = response.data.data.messages
          this.scrollToItem()
        }).catch(error => {
          console.log(error);
        })
    }
  },

  created(){
      this.chat_id = this.$route.params.id;
      this.isStartDateValid()
      this.getChat()
    },
};
</script>
<style scoped>
.scrollable-sheet {
  flex-direction: column-reverse; /* Cambia la dirección del flex a inversa */
}

.scroll-container {
  max-height: 100%;
}
.section-chat{
  height: 84%;
  overflow-y: auto;
}
.section-message{
  height: auto;
}
.speech-bubble {
  position: relative;
  background-color: #f1f1f1;
  border-radius: 10px;
  padding: 10px;
  margin: 10px;
  max-width: 300px;
}

.speech-bubble::before {
  content: '';
  position: absolute;
  border-style: solid;
  border-width: 10px;
  border-color: transparent transparent #f1f1f1 #f1f1f1;
  bottom: -20px;
  right: 0;
}
</style>
